import { useState } from "react";
import { Star } from "lucide-react";

export const Stars = ({ value = 0, size = "h-4 w-4", testId }) => (
  <span data-testid={testId} className="inline-flex items-center gap-0.5">
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
    ))}
  </span>
);

export const StarPicker = ({ onSubmit, testPrefix = "rate" }) => {
  const [stars, setStars] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    await onSubmit(stars, comment);
    setBusy(false);
  };
  return (
    <div className="space-y-3" data-testid={`${testPrefix}-picker`}>
      <div className="flex gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((n) => (
          <button key={n} type="button" data-testid={`${testPrefix}-star-${n}`} onMouseEnter={() => setHover(n)} onClick={() => setStars(n)} className="transition-transform hover:scale-110">
            <Star className={`h-8 w-8 ${n <= (hover || stars) ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
          </button>
        ))}
      </div>
      {stars > 0 && (
        <>
          <input data-testid={`${testPrefix}-comment-input`} value={comment} maxLength={300} onChange={(e) => setComment(e.target.value)} placeholder="Add a comment (optional)" className="h-10 w-full rounded-xl border border-slate-200 bg-white px-3 text-sm outline-none focus:border-blue-600" />
          <button data-testid={`${testPrefix}-submit-button`} disabled={busy} onClick={submit} className="rounded-xl bg-blue-700 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-600 disabled:opacity-60">Submit rating</button>
        </>
      )}
    </div>
  );
};
